import { useRolePermissionsByRoleId } from "../../data/queries/rolePermissionQueries";
import useRolePermissionStore from "../../store/rolePermissionStore";
import { IconLoading } from "../../components/Loading/IconLoading";
import { useEffect } from "react";
import { useDueDatesAuth } from "../../hooks/useDueDatesAuth";

const RolePermissionsComponent = () => {
  const getUserRoleId = (role) => {
    switch (role) {
      case "Administrator":
        return 1;
      case "Manager":
        return 2;
      case "Staff":
        return 3;
      case "DataEntry":
        return 4;
      default:
        break;
    }
  };

  const { UserRole, loading } = useDueDatesAuth();

  const roleId = getUserRoleId(UserRole);

  const { data, isPending, isSuccess } = useRolePermissionsByRoleId(roleId);
  const setRolePermissions = useRolePermissionStore(
    (state) => state.setRolePermissions
  );

  useEffect(() => {
    if (isSuccess) {
      setRolePermissions(data);
    }
  }, [isSuccess, data, setRolePermissions]);

  if (roleId === null || loading || isPending) return <IconLoading />;

  return null;
};

export default RolePermissionsComponent;
